<template>
  <div class="google-map">
    <div ref="googleMap" class="google-map"></div>
    <template v-if="Boolean(google) && Boolean(map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>

<script>
import { mapSettings } from "./mapSettings";

export default {
  props: {
    mapConfig: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    zoom: {
      type: Number,
      required: false,
      default() {
        return 10;
      },
    },
    center: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      google: null,
      map: null,
    };
  },
  computed: {
    config() {
      return {
        ...mapSettings,
        ...this.mapConfig,
      };
    },
  },
  watch: {
    zoom(newVal) {
      this.map.setZoom(newVal);
    },
    center(newVal) {
      this.map.setCenter(newVal);
    },
  },

  mounted() {
    this.setGoogleMapsObject();
  },

  methods: {
    setGoogleMapsObject() {
      window.withGoogleMapsLoaded(() => {
        this.google = window.google;
        this.initializeMap();
      });
    },
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.config);
      this.$emit("map-loaded");
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100%;
}
</style>
